module.exports = __webpack_public_path__ + "static/media/sms-active.2d94ed13.svg";